import axiosNest from '../../api/axiosNest';

/**
 * Prawo spółki do Trade i giełd — odpowiada `PUT /companies/:id/trade-allowed`.
 *
 * Ustalenie ze statusu 29.09.2026: konta giełdowe ma tylko spółka polska,
 * więc zleceń spółki niemieckiej nie przekazuje się do Trade i nie publikuje.
 * Zdjęcie blokady (gdy spółka dostanie konto) to ten zapis, z powodem.
 */
export async function saveTradeAllowed(
  companyId: number | string,
  tradeAllowed: boolean,
  reason: string,
): Promise<void> {
  await axiosNest.put(`/companies/${companyId}/trade-allowed`, { tradeAllowed, reason });
}

/** Flaga z rekordu. Brak pola (starsze API) = nie wiemy, więc nie pokazujemy blokady. */
export function tradeAllowedOf(record: Record<string, unknown>): boolean | null {
  const v = record.tradeAllowed;
  return typeof v === 'boolean' ? v : null;
}
